import PropertyInput from "../components/inputs/input-property.tsx";
import {H, ViewCopy, ViewDialog} from "../components/view.tsx";

export default function ViewBase1() {
  return (<ViewDialog ><ViewBase1Form /> </ViewDialog>)
}

export function ViewBase1Form() {
  return (<>
            <ViewCopy><H>Um welches Gebäude handelt es sich?</H></ViewCopy>
            <PropertyInput type="gebaeude_typ"/>
          </>)
}